import React from 'react'
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import AppInputNumber from "../../ui/AppInputNumber";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import DialogContent from "@material-ui/core/DialogContent";
import ValidateForm from "../../helpers/ValidateForm";
import AppToast from "../../ui/AppToast";
import AppInputText from "../../ui/AppInputText"

const initialForm = {
    tipoDireccion: {
        key: 'tipoDireccion',
        value: '',
        required: true
    },
    numeroTipoDireccion: {
        key: 'numeroTipoDireccion',
        value: '',
        required: true
    },
    primerSufijoTipoDireccion: {
        key: 'primerSufijoTipoDireccion',
        value: '',
        required: false
    },
    segundoSufijoTipoDireccion: {
        key: 'segundoSufijoTipoDireccion',
        value: '',
        required: false
    },
    tercerSufijoTipoDireccion: {
        key: 'tercerSufijoTipoDireccion',
        value: '',
        required: false
    },
    puntoCardinalTipoDireccion: {
        key: 'puntoCardinalTipoDireccion',
        value: '',
        required: false
    },
    primerNumeroDireccion: {
        key: 'primerNumeroDireccion',
        value: '',
        required: true
    },
    primerSufijoDireccion: {
        key: 'primerSufijoDireccion',
        value: '',
        required: false
    },
    segundoSufijoDireccion: {
        key: 'segundoSufijoDireccion',
        value: '',
        required: false
    },
    tercerSufijoDireccion: {
        key: 'tercerSufijoDireccion',
        value: '',
        required: false
    },
    puntoCardinalDireccion: {
        key: 'puntoCardinalDireccion',
        value: '',
        required: false
    },
    segundoNumeroDireccion: {
        key: 'segundoNumeroDireccion',
        value: '',
        required: true
    },
    adicionalPrimerTipo: {
        key: 'adicionalPrimerTipo',
        value: '',
        required: false
    },
    adicionalPrimerNumero: {
        key: 'adicionalPrimerNumero',
        value: '',
        required: false
    },
    adicionalSegundoTipo: {
        key: 'adicionalSegundoTipo',
        value: '',
        required: false
    },
    adicionalSegundoNumero: {
        key: 'adicionalSegundoNumero',
        value: '',
        required: false
    },
    adicionalTercerTipo: {
        key: 'adicionalTercerTipo',
        value: '',
        required: false
    },
    adicionalTercerNumero: {
        key: 'adicionalTercerNumero',
        value: '',
        required: false
    },
};

const location = {
    typeAddress: [
        {value: 'C', detalle: 'CALLE'},
        {value: 'K', detalle: 'CARRERA'},
        {value: 'A', detalle: 'AVENIDA'},
        {value: 'Au', detalle: 'AUTOPISTA'},
        {value: 'T', detalle: 'TRANSVERSAL'},
        {value: 'D', detalle: 'DIAGONAL'},
    ],
    sufixTypeAddress: [
        {detalle: ''},
        {detalle: 'A'},
        {detalle: 'B'},
        {detalle: 'C'},
        {detalle: 'D'},
        {detalle: 'E'},
        {detalle: 'F'},
        {detalle: 'G'},
        {detalle: 'H'},
        {detalle: 'I'},
        {detalle: 'J'},
        {detalle: 'K'},
        {detalle: 'L'},
        {detalle: 'M'},
        {detalle: 'N'},
        {detalle: 'Ñ'},
        {detalle: 'O'},
        {detalle: 'P'},
        {detalle: 'Q'},
        {detalle: 'R'},
        {detalle: 'S'},
        {detalle: 'T'},
        {detalle: 'U'},
        {detalle: 'V'},
        {detalle: 'W'},
        {detalle: 'X'},
        {detalle: 'Y'},
        {detalle: 'Z'},
    ],
    cardinalPointTypeAddress: [
        {detalle: ''},
        {detalle: 'BIS'},
    ],
    cardinalPointAddress: [
        {value: '', detalle: ''},
        {value: 'W', detalle: 'OESTE'},
        {value: 'S', detalle: 'SUR'},
    ],
    dataAditional: [
        {value: '', detalle: ''},
        {value: 'Of', detalle: 'OFICINA'},
        {value: 'Ed', detalle: 'EDIFICIO'},
        {value: 'To', detalle: 'TORRE'},
        {value: 'Mz', detalle: 'MANZANA'},
        {value: 'Lo', detalle: 'LOTE'},
        {value: 'Cs', detalle: 'CASA'},
        {value: 'Ap', detalle: 'APARTAMENTO'},
        {value: 'Vr', detalle: 'VEREDA'},
        {value: 'Km', detalle: 'KILOMETRO'},
        {value: 'L', detalle: 'LOCAL'},
    ]
};

class GenerarDireccion extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            form: initialForm,
            direccion: '',
        };

        this.generateAddress = this.generateAddress.bind(this);
        // console.log(this.props.tipoZona);

    }

    async componentDidMount() {

    }

    handleChange = async (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
                return {
                    form: {
                        ...statePrev.form,
                        [name]: {
                            ...statePrev.form[name],
                            value: value
                        }
                    }
                }
            }, () => {
                this.setState({direccion: this.generateAddress()})
            }
        );

    }

    generateAddress = () => {

        const data = this.state.form;

        let fullAddress = '';
        fullAddress = fullAddress.concat(
            data.tipoDireccion.value.toString(), ' ',
            data.numeroTipoDireccion.value.toString(), ' ',
            data.primerSufijoTipoDireccion.value.toString(), '',
            data.tercerSufijoTipoDireccion.value.toString(), ' ',
            data.segundoSufijoTipoDireccion.value.toString(), ' ',
            data.puntoCardinalTipoDireccion.value.toString(), ' ',
            data.primerNumeroDireccion.value.toString(), ' ',
            data.primerSufijoDireccion.value.toString(), '',
            data.tercerSufijoDireccion.value.toString(), ' ',
            data.segundoSufijoDireccion.value.toString(), ' ',
            data.segundoNumeroDireccion.value.toString(), ' ',
            data.puntoCardinalDireccion.value.toString(), ' ',
            data.adicionalPrimerTipo.value.toString(), ' ',
            data.adicionalPrimerNumero.value.toString(), ' ',
            data.adicionalSegundoTipo.value.toString(), ' ',
            data.adicionalSegundoNumero.value.toString(), ' ',
            data.adicionalTercerTipo.value.toString(), ' ',
            data.adicionalTercerNumero.value.toString()
        );

        fullAddress = fullAddress.replace(/\s\s+/g, ' ').trim();

        return fullAddress;

    }

    enviarDireccion = () => {
        if(this.props.tipoZona==='U')
        {
            if (!ValidateForm(this.state.form)) {
                return false;
            }
        }
        if (!this.state.direccion) {
            AppToast('Debe generar la dirección.', false);
            return false;
        }

        this.props.setDireccion(this.props.currentKey, this.state.direccion);
        this.props.onClose();

    }


    render() {

        const {onClose} = this.props;

        return (
            <DialogContent style={{padding: '0px'}}>
                <AppBar style={{position: 'relative'}}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={onClose}
                                    aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Typography variant="h6">
                            <b>Generar Dirección</b>
                        </Typography>

                        <section style={{
                            marginLeft: "auto",
                            marginRight: -12
                        }}>
                            <IconButton color="inherit" onClick={this.enviarDireccion}
                                        aria-label="close">
                                <SaveIcon/>
                            </IconButton>
                        </section>

                    </Toolbar>
                </AppBar>

                <div style={{padding: '30px'}}>

                    <h3 style={{marginBottom: '20px', textAlign: 'center'}}>{this.state.direccion}</h3>

                    {
                        this.props.tipoZona==='U' ?
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <FormControl required variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Tipo dirección</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.tipoDireccion.key}
                                        name={this.state.form.tipoDireccion.key}
                                        value={this.state.form.tipoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Tipo Documento"
                                        required={((this.props.tipoZona==='U') ? this.state.form.tipoDireccion.required : false)}
                                        variant='outlined'
                                    >

                                        {location.typeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.value}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <AppInputNumber
                                    id={this.state.form.numeroTipoDireccion.key}
                                    name={this.state.form.numeroTipoDireccion.key}
                                    value={this.state.form.numeroTipoDireccion.value}
                                    label='Número'
                                    onChange={this.handleChange}
                                    required={((this.props.tipoZona==='U') ? this.state.form.numeroTipoDireccion.required : false)}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Sufijo Principal</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.primerSufijoTipoDireccion.key}
                                        name={this.state.form.primerSufijoTipoDireccion.key}
                                        value={this.state.form.primerSufijoTipoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Sufijo Principal"
                                        variant='outlined'
                                    >

                                        {location.sufixTypeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.detalle}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Sufijo Secundario</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.tercerSufijoTipoDireccion.key}
                                        name={this.state.form.tercerSufijoTipoDireccion.key}
                                        value={this.state.form.tercerSufijoTipoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Sufijo Secundario"
                                        variant='outlined'
                                    >

                                        {location.sufixTypeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.detalle}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Sufijo BIS</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.segundoSufijoTipoDireccion.key}
                                        name={this.state.form.segundoSufijoTipoDireccion.key}
                                        value={this.state.form.segundoSufijoTipoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Sufijo BIS"
                                        variant='outlined'
                                    >

                                        {location.cardinalPointTypeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.detalle}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={3}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Punto Cardinal</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.puntoCardinalTipoDireccion.key}
                                        name={this.state.form.puntoCardinalTipoDireccion.key}
                                        value={this.state.form.puntoCardinalTipoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Punto Cardinal"
                                        variant='outlined'
                                    >

                                        {location.cardinalPointAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.value}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <AppInputNumber
                                    id={this.state.form.primerNumeroDireccion.key}
                                    name={this.state.form.primerNumeroDireccion.key}
                                    value={this.state.form.primerNumeroDireccion.value}
                                    label='Número'
                                    onChange={this.handleChange}
                                    required={((this.props.tipoZona==='U') ? this.state.form.primerNumeroDireccion.required : false)}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Sufijo Principal</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.primerSufijoDireccion.key}
                                        name={this.state.form.primerSufijoDireccion.key}
                                        value={this.state.form.primerSufijoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Sufijo"
                                        variant='outlined'
                                    >

                                        {location.sufixTypeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.detalle}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Sufijo Secundario</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.tercerSufijoDireccion.key}
                                        name={this.state.form.tercerSufijoDireccion.key}
                                        value={this.state.form.tercerSufijoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Sufijo"
                                        variant='outlined'
                                    >

                                        {location.sufixTypeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.detalle}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Sufijo BIS</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.segundoSufijoDireccion.key}
                                        name={this.state.form.segundoSufijoDireccion.key}
                                        value={this.state.form.segundoSufijoDireccion.value}
                                        onChange={this.handleChange}
                                        label="Sufijo"
                                        variant='outlined'
                                    >

                                        {location.cardinalPointTypeAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.detalle}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl variant="outlined" style={{width: '100%'}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Punto Cardinal</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id={this.state.form.puntoCardinalDireccion.key}
                                        name={this.state.form.puntoCardinalDireccion.key}
                                        value={this.state.form.puntoCardinalDireccion.value}
                                        onChange={this.handleChange}
                                        label="Punto Cardinal"
                                        variant='outlined'
                                    >

                                        {location.cardinalPointAddress.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.value}>{val.detalle}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <AppInputNumber
                                    id={this.state.form.segundoNumeroDireccion.key}
                                    name={this.state.form.segundoNumeroDireccion.key}
                                    value={this.state.form.segundoNumeroDireccion.value}
                                    label='Número'
                                    onChange={this.handleChange}
                                    required={((this.props.tipoZona==='U') ? this.state.form.segundoNumeroDireccion.required : false)}
                                />
                            </Grid>
                        </Grid>
                        : null
                    }

                    <p>Los siguientes campos no son obligatorios. Complételos solamente si es necesario.</p>
                    <Grid container spacing={1}>
                        <Grid item xs={5}>
                            <FormControl variant="outlined" style={{width: '100%'}}>
                                <InputLabel id="demo-simple-select-outlined-label">Datos Adicionales</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id={this.state.form.adicionalPrimerTipo.key}
                                    name={this.state.form.adicionalPrimerTipo.key}
                                    value={this.state.form.adicionalPrimerTipo.value}
                                    onChange={this.handleChange}
                                    label="Datos Adicionales"
                                    variant='outlined'
                                >

                                    {location.dataAditional.map((val, index) => {
                                        return (
                                            <MenuItem key={index}
                                                      value={val.value}>{val.detalle}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={5}>
                            <AppInputText
                                id={this.state.form.adicionalPrimerNumero.key}
                                name={this.state.form.adicionalPrimerNumero.key}
                                value={this.state.form.adicionalPrimerNumero.value}
                                label='Número'
                                onChange={this.handleChange}
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <FormControl variant="outlined" style={{width: '100%'}}>
                                <InputLabel id="demo-simple-select-outlined-label">Datos Adicionales</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id={this.state.form.adicionalSegundoTipo.key}
                                    name={this.state.form.adicionalSegundoTipo.key}
                                    value={this.state.form.adicionalSegundoTipo.value}
                                    onChange={this.handleChange}
                                    label="Datos Adicionales"
                                    variant='outlined'
                                >

                                    {location.dataAditional.map((val, index) => {
                                        return (
                                            <MenuItem key={index}
                                                      value={val.value}>{val.detalle}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={5}>
                            <AppInputText
                                id={this.state.form.adicionalSegundoNumero.key}
                                name={this.state.form.adicionalSegundoNumero.key}
                                value={this.state.form.adicionalSegundoNumero.value}
                                label='Número'
                                onChange={this.handleChange}
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <FormControl variant="outlined" style={{width: '100%'}}>
                                <InputLabel id="demo-simple-select-outlined-label">Datos Adicionales</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id={this.state.form.adicionalTercerTipo.key}
                                    name={this.state.form.adicionalTercerTipo.key}
                                    value={this.state.form.adicionalTercerTipo.value}
                                    onChange={this.handleChange}
                                    label="Datos Adicionales"
                                    variant='outlined'
                                >

                                    {location.dataAditional.map((val, index) => {
                                        return (
                                            <MenuItem key={index}
                                                      value={val.value}>{val.detalle}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={5}>
                            <AppInputText
                                id={this.state.form.adicionalTercerNumero.key}
                                name={this.state.form.adicionalTercerNumero.key}
                                value={this.state.form.adicionalTercerNumero.value}
                                label='Número'
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>

                </div>

            </DialogContent>
        );
    }
}

export default GenerarDireccion
